import { bytesToString, formatNumber } from 'js/lib/FormatUtils';
import Constants from 'js/Constants';

type HandleLifetimeMetrics = {
  size: number | string;
  records: number | string;
  errors: number | string;
} | null;

function handleLifetimeMetrics(metric: HandleLifetimeMetrics) {
  if (!metric) {
    return {
      volume: Constants.DATA_NOT_AVAILABLE,
      errors: Constants.DATA_NOT_AVAILABLE,
      records: Constants.DATA_NOT_AVAILABLE,
    };
  }

  let totalVolume: string, numRecords: string, numberErrors: string;

  totalVolume = metric?.size ? bytesToString(metric.size) : '0B';

  numRecords = metric?.records ? formatNumber(metric?.records) : '0';

  numberErrors = metric?.errors ? formatNumber(metric?.errors) : '0';

  return {
    volume: totalVolume,
    errors: numberErrors,
    records: numRecords,
  };
}

export const MetricsUtil = {
  handleLifetimeMetrics,
};
